<template>
  <vue-draggable-resizable
    class="draggableItem custom-code-edit"
    drag-cancel=".dragCancel"
    :id="codeKey"
  >
    <div class="draggableItem__header">
      <span class="draggableItem__title">Custome code: {{ codeVal.name }}.{{ codeType }}</span>
      <a
        href="#"
        class="draggableItem__close dragCancel"
        @click.prevent="close"
        v-b-tooltip.hover
        title="close"
      >
        <icon name="remove" />
      </a>
    </div>
    <div class="draggableItem__body">
      <codemirror
        :value="code"
        :options="cmOptions"
        @input="onCmCodeChange"
        @keydown.ctrl.83.native.prevent="save"
        class="dragCancel"
        :ref="'draggable_' + codeKey"
      />
      <div class="submitComputed">
        <b-button
          variant="primary"
          size="sm"
          type="submit"
          :disabled="!changed"
          class="dragCancel"
          @click="save"
        >
          Save
        </b-button>
      </div>
    </div>
  </vue-draggable-resizable>
</template>

<script>
// services
import db from '@/services/db'
// helpers
import constants from '@/helpers/constants'

let $ = window.$

export default {
  props: ['codeKey', 'codeVal', 'codeType'],
  data() {
    return {
      code: this.codeVal.code,
      width: 0,
      height: 0,
      x: 0,
      y: 0,
    }
  },
  computed: {
    changed() {
      if (this.code != this.codeVal.code) return true // eslint-disable-line
      return false
    },
    cmOptions() {
      switch (this.codeType) {
        case 'css':
          return constants.cmStylesOptions
        case 'js':
          return constants.cmScriptOptions
        case 'html':
          return constants.cmTemplateOptions
      }
    },
  },
  methods: {
    close() {
      let vm = this
      this.$store.commit('editCustomCode', {
        key: vm.codeKey,
        insert: false,
      })
    },
    onCmCodeChange(code) {
      this.code = code
    },
    save() {
      db.customCode.update(this.codeKey, this.codeType, this.code, err => {
        if (err) this.$store.commit('addError', err.message)
      })
    },
    getMode() {
      let mode = ''

      switch (this.codeType) {
        case 'css':
          mode = 'text/css'
          break
        case 'js':
          mode = 'text/javascript'
          break
        default:
          mode = 'text/x-vue'
      }

      return mode
    },
  },
  mounted() {
    $(this.$refs['draggable_' + this.codeKey].$el)
      .find('textarea')
      .focus()
  },
}
</script>

<style lang="scss">
@import '~$scss/globals';

.custom-code-edit {
  .submitComputed {
    margin-top: 15px;
  }
  .vue-codemirror {
    height: calc(100% - 46px);
    border: 1px solid $borderColor1;
  }
  .draggableItem .CodeMirror {
    height: 100%;
  }
}
</style>
